module.exports = __webpack_public_path__ + "static/img/hitler0.62814fe.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/role/hitler0.png
// module id = 73
// module chunks = 0